import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'RadioOn',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M6.5 12.5c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm14 6h-7m7-2h-7m7-2h-7m8-8h-19c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h19c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2zm-19 0l10-5" }
      }), h("path", {
        attrs: { d: "M6.5 14a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5zM16 8H3c-.55 0-1 .45-1 1s.45 1 1 1h13V8zm5 0h-4v2h4c.55 0 1-.45 1-1s-.45-1-1-1z" }
      })]
    );
  }
};